<template>
  <section id="google-location-map" class="mt-3">
    <h4 class="mb-2">
      <i class="fas fa-map-marker-alt text-primary"></i> MTD Locations
    </h4>

    <GMapMap 
      :center="center"
      ref="googleMap"
      :zoom="4"
 :options="{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false
 }"
      style="width: 70vw; height: 500px"
    >
      <GMapMarker 
        :key="index"
        :position="marker.position"
        :clickable="true"
        @click="openMarker(marker.id)"
        v-for="(marker, index) in markers">
        <GMapInfoWindow
          :closeclick="true"
          @closeclick="openMarker(null)"
          :opened="openedMarkerID === marker.id"
        >
          <p v-if="marker.info.address.company_name" class="font-weight-bold mb-1">{{marker.info.address.company_name}} - {{marker.info.address.first_name}} {{marker.info.address.last_name}}</p>
          <p v-if="marker.info.address.address1" class="mb-1">
            {{marker.info.address.address1}} {{marker.info.address.city}} - {{marker.info.address.state}} {{marker.info.address.postcode}}
          </p>
          <p v-if="marker.info.address.email" class="text-secondary"><Email v-model="marker.info.address.email" /></p>
          <p v-if="marker.info.address.phone" class="text-secondary"><Phone v-model="marker.info.address.phone" /></p>
          <ul class="list-unstyled mb-0">
            <li v-if="marker.info.status">Status:
              <span class="text-secondary">{{marker.info.status}}</span>
            </li>
            <li v-if="marker.info.rsm">RSM: 
              <span class="text-secondary">{{marker.info.rsm}}</span>
            </li>
            <li v-if="marker.info.last_order">Last Order: 
              <span class="text-secondary">{{moment(marker.info.last_order).format('M/D/YY')}}</span>
            </li>
            <li v-if="marker.info.last_activity_at">Last Active: 
              <span class="text-secondary">{{ moment.utc(marker.info.last_activity_at).format('M/D/YY') }}</span>
            </li>
            <li v-if="marker.info.cart_value">Current Cart: 
              <span class="text-secondary">{{formatCurrency(marker.info.cart_value)}}</span>
            </li>
          </ul>
        </GMapInfoWindow>
      </GMapMarker>
    </GMapMap>
  </section>
</template>

<script>
  import moment from 'moment'
  import { debounce } from "lodash"
  
  export default {
    data() {
      return {
        openedMarkerID: null,
        center: {lat:39.8097343, lng:-98.5556199},
        markers: []
      }
    },
    mounted() {
      this.makeMarkers()
    },
    created() {
      this.moment = moment;
    },
    methods: {
      openMarker(id) {
        this.openedMarkerID = id
      },
      makeMarkers() {
        this.$refs.googleMap.$mapPromise.then( map => {
          this.users.forEach( (user, index) => {
            if (!user.address || 
              !user.address.gapi_place_details || 
              !user.address.gapi_place_details.geometry) return

            const coods = user.address.gapi_place_details.geometry.location;
          
            this.markers.push({
              id: index,
              position: {
                lat: coods.lat,
                lng: coods.lng
              },
              info: {
                address: user.address,
                rsm: user.rsm,
                last_order: user.last_order,
                last_activity_at: user.last_activity_at,
                cart_value: user.cart_value,
                status: user.status
              }
            })
          })
        })
      },
      remakeMarkers: debounce(function() {
        this.markers = []
        this.makeMarkers()
      }, 1000)
    },
    props: {
      users: Array
    },
  }
</script>
